import React from "react";
import pdfFile from "../pdfs/OnboardingYourHotel-B2C.pdf";
import PdfViewer from "../comman/PdfViewer";
import { onboardingDocs } from "../consfig";

const Onboarding = () => {
  const pdfUrl = onboardingDocs.b2c.onBoardHotel;
  return <PdfViewer pdfFile={pdfUrl} />;
};

export default Onboarding;
